import MyNavbar from "./nav";


export default function Header(){
    return(
        <div  id='Header'>
            <MyNavbar></MyNavbar>
        </div>
    )
}